import script from "./tag-list.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-list.vue?vue&type=script&setup=true&lang=js"

import "./tag-list.vue?vue&type=style&index=0&id=e7951e7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7951e7e"]])

export default __exports__